<!-- @format -->

<ng-container *transloco="let t">
  @if (workflow) {
    <fudis-dialog [size]="'lg'">
      <div class="modal-header">
        <fudis-heading [level]="2">
          @if (isApproved()) {
            {{ t("SHOW_MODULE_CONTENT_APPROVAL_MODAL." + applicationType + ".MODAL_TITLE.APPROVED") }}
          } @else if (isRejected()) {
            {{ t("SHOW_MODULE_CONTENT_APPROVAL_MODAL." + applicationType + ".MODAL_TITLE.REJECTED") }}
          } @else {
            {{ t("SHOW_MODULE_CONTENT_APPROVAL_MODAL." + applicationType + ".MODAL_TITLE.PENDING_APPROVAL") }}
          }
        </fudis-heading>
      </div>
      <div class="modal-body">
        @if (showApplicationCancellationDisabledAlert) {
          <fudis-notification class="fudis-mb-xs" [variant]="'danger'">
            <fudis-body-text>{{ t("PROFILE.APPLICATIONS.APPLICATION_CANCELLATION_DISABLED_ALERT") }}</fudis-body-text>
          </fudis-notification>
        } @else if (showApplicationRevocationDisabledAlert) {
          <fudis-notification class="fudis-mb-xs" [variant]="'danger'">
            <fudis-body-text>{{ t("PROFILE.APPLICATIONS.APPLICATION_REVOKE_DISABLED_ALERT") }}</fudis-body-text>
          </fudis-notification>
        }
        @if (workflow.initiatorType === "STAFF") {
          <fudis-notification class="fudis-mb-xl" [variant]="'info'">
            <fudis-body-text>{{ t("PROFILE.APPLICATIONS.APPLICATION_CREATED_BY_STAFF") }}</fudis-body-text>
          </fudis-notification>
        }
        <div class="row">
          <transloco
            key="{{ 'SHOW_MODULE_CONTENT_APPROVAL_MODAL.' + applicationType + '.SITUATION_DESCRIPTION.' + workflow.state }}"
            [params]="{ modulename: parentModule.name | localizedString }">
          </transloco>
        </div>
        <div class="row mt-2">
          <transloco
            key="{{ 'SHOW_MODULE_CONTENT_APPROVAL_MODAL.' + applicationType + '.SENT_ON' | translate }}"
            [params]="{ createdOn: (workflow.metadata?.createdOn | localDateFormat) }">
          </transloco>
        </div>
        <div class="row">
          <fudis-heading [level]="3" [variant]="'md'" class="fudis-mt-sm">{{ parentModule.name | localizedString }}</fudis-heading>
          @for (courseUnitGroupId of workflow.courseUnitSelections; track courseUnitGroupId) {
            @if (courseUnitGroupId | courseUnitByGroupId | async; as courseUnit) {
              <sis-plan-structure-course-unit
                class="fudis-mb-sm"
                [courseUnit]="courseUnit"
                [planStateObject]="planStateObject"
                [planData]="planData"
                [headingLevel]="4"
                [showCompletionMethodSelection]="false"
                [nameClickable]="false"
                [showAttainment]="false">
              </sis-plan-structure-course-unit>
            }
          }
          @for (customStudyDraft of workflow.customStudyDrafts; track customStudyDraft.id) {
            <sis-plan-structure-custom-study-draft
              class="fudis-mb-sm"
              [customStudyDraft]="customStudyDraft"
              [nameClickable]="false"
              [headingLevel]="4">
            </sis-plan-structure-custom-study-draft>
          }
          @for (customCourseUnitAttainmentId of workflow.customCourseUnitAttainmentSelections; track customCourseUnitAttainmentId) {
            @if (getCustomCourseUnitAttainment(customCourseUnitAttainmentId); as customCourseUnitAttainment) {
              <sis-plan-structure-custom-course-unit-attainment
                class="fudis-mb-sm"
                [customCourseUnitAttainment]="customCourseUnitAttainment"
                [planStateObject]="planStateObject"
                [nameClickable]="false"
                [headingLevel]="4">
              </sis-plan-structure-custom-course-unit-attainment>
            }
          }
          @for (moduleGroupId of workflow.moduleSelections; track moduleGroupId) {
            @if (moduleGroupId | moduleGroup | async; as module) {
              @if (module.type === "DegreeProgramme") {
                <sis-plan-structure-degree-programme-box
                  class="fudis-mb-sm"
                  [module]="$any(module)"
                  [planStateObject]="planStateObject"
                  [planData]="planData"
                  [headingLevel]="4"
                  [selected]="validatablePlan.isModuleInPlan(module.id)"
                  [nameClickable]="false">
                </sis-plan-structure-degree-programme-box>
              }
              @if (module.type === "StudyModule") {
                <sis-plan-structure-study-module-box
                  class="fudis-mb-sm"
                  [module]="$any(module)"
                  [planStateObject]="planStateObject"
                  [planData]="planData"
                  [headingLevel]="4"
                  [selected]="validatablePlan.isModuleInPlan(module.id)"
                  [nameClickable]="false">
                </sis-plan-structure-study-module-box>
              }
              @if (module.type === "GroupingModule") {
                <fudis-heading [level]="4" [variant]="'xs'">{{ module.name | localizedString }}</fudis-heading>
              }
            }
          }
        </div>
        <fudis-section
          class="mt-4"
          [level]="3"
          [titleVariant]="'md'"
          [title]="t('MODULE_CONTENT_APPROVAL_MODAL.' + approvalRequestType + '.APPLICATION_RATIONALE_TITLE')">
          <fudis-section-content>
            <fudis-body-text>{{ workflow.applicationRationale }}</fudis-body-text>
          </fudis-section-content>
        </fudis-section>
        @if (isApproved() || isRejected()) {
          <fudis-section class="mt-4" [level]="3" [titleVariant]="'md'" [title]="t('MODULE_CONTENT_APPROVAL_MODAL.APPLICATION_DECISION')">
            <fudis-section-content>
              <fudis-grid [columns]="2">
                <fudis-grid-item>
                  <fudis-dl>
                    <fudis-dl-item>
                      <fudis-dt [contentText]="t('STUDENT_APPLICATIONS.DECISION')" />
                      <fudis-dd>
                        @if (isAccepted()) {
                          {{ t("SHOW_MODULE_CONTENT_APPROVAL_MODAL." + applicationType + ".APPROVED") }}
                        } @else if (isConditional()) {
                          {{ t("SHOW_MODULE_CONTENT_APPROVAL_MODAL." + applicationType + ".APPROVED_CONDITIONALLY") }}
                        } @else if (isRejected()) {
                          {{ t("SHOW_MODULE_CONTENT_APPROVAL_MODAL." + applicationType + ".REJECTED") }}
                        }
                      </fudis-dd>
                    </fudis-dl-item>
                  </fudis-dl>
                </fudis-grid-item>
                <fudis-grid-item>
                  @if (workflow.decision?.resolutionRationale) {
                    <fudis-dl>
                      <fudis-dl-item>
                        <fudis-dt [contentText]="t('SHOW_MODULE_CONTENT_APPROVAL_MODAL.' + applicationType + '.RESOLUTION_RATIONALE')" />
                        <fudis-dd [contentText]="workflow.decision?.resolutionRationale" />
                      </fudis-dl-item>
                    </fudis-dl>
                  }
                  @if (isConditional() && workflow.decision?.type === "ModuleContentWorkflowDecision") {
                    <fudis-dl>
                      <fudis-dl-item>
                        <fudis-dt [contentText]="t('SHOW_MODULE_CONTENT_APPROVAL_MODAL.' + applicationType + '.CONDITIONS')" />
                        <fudis-dd [contentText]="castToModuleContentWorkflowDecision(workflow.decision)?.conditionalApprovalTerms" />
                      </fudis-dl-item>
                    </fudis-dl>
                  }
                </fudis-grid-item>
              </fudis-grid>
              <sis-recommendation
                [formalRecommendation]="workflowDecision?.formalRecommendation"
                [contentRecommendation]="workflowDecision?.contentRecommendation"
                [approvalRequestType]="castToWorkflowTypeEnumValue(applicationType)">
              </sis-recommendation>
              <fudis-grid [columns]="2">
                <fudis-grid-item>
                  <fudis-dl>
                    <fudis-dl-item>
                      <fudis-dt [contentText]="t('STUDENT_APPLICATIONS.APPROVAL_DATE')" />
                      <fudis-dd [contentText]="workflow.decision?.approvalDate | localDateFormat" />
                    </fudis-dl-item>
                  </fudis-dl>
                </fudis-grid-item>
                <fudis-grid-item>
                  <fudis-dl>
                    <fudis-dl-item>
                      <fudis-dt [contentText]="t('STUDENT_APPLICATIONS.HANDLED_BY')" />
                      <fudis-dd>
                        <span>{{ workflow.decision?.approvedBy | publicPerson | async | personFullName }}</span>
                        @if (workflow.decision?.approverTitle) {
                          <span>, {{ workflow.decision?.approverTitle }}</span>
                        }
                      </fudis-dd>
                    </fudis-dl-item>
                  </fudis-dl>
                </fudis-grid-item>
              </fudis-grid>
            </fudis-section-content>
          </fudis-section>
        }
      </div>
      <div class="modal-footer">
        <sis-button [size]="'lg'" [hollow]="true" (clicked)="close()">{{ t("CANCEL") }} </sis-button>
        @if (isPendingApproval()) {
          <sis-button [size]="'lg'" (clicked)="cancelApplication()">
            {{ t("SHOW_MODULE_CONTENT_APPROVAL_MODAL." + applicationType + ".CANCEL_REQUEST") }}
          </sis-button>
        } @else if (isApproved()) {
          <sis-button [size]="'lg'" (clicked)="revokeApplication()">
            {{ t("SHOW_MODULE_CONTENT_APPROVAL_MODAL." + applicationType + ".REVOKE_APPROVAL") }}
          </sis-button>
        }
      </div>
    </fudis-dialog>
  }
</ng-container>
